export interface AuthData {
  email: string;
  role: string;
  accessToken: string;
  refreshToken: string;
  expiresIn: number;
}

const AUTH_KEY = 'alubike_auth';

export const saveAuthData = (authData: AuthData): void => {
  localStorage.setItem(AUTH_KEY, JSON.stringify(authData));
};

export const getAuthData = (): AuthData | null => {
  const data = localStorage.getItem(AUTH_KEY);
  if (!data) return null;
  
  try {
    return JSON.parse(data) as AuthData;
  } catch {
    return null;
  }
};

export const removeAuthData = (): void => {
  localStorage.removeItem(AUTH_KEY);
};

export const getAccessToken = (): string | null => {
  const authData = getAuthData();
  return authData ? authData.accessToken : null;
};

export const getRefreshToken = (): string | null => {
  const authData = getAuthData();
  return authData ? authData.refreshToken : null;
};

export const getUserRole = (): string | null => {
  const authData = getAuthData();
  return authData ? authData.role : null;
}; 